import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScholarshipSessionStoreActions,
  ScholarshipSessionStoreSelectors,
  ScholarshipSessionStoreReducer,
} from './index';
import { ScholarshipSessionDto } from '@cradua/data';

@Injectable()
export class ScholarshipSessionFacade {
  constructor(
    private store: Store<
      ScholarshipSessionStoreReducer.ScholarshipSessionPartialState
    >
  ) {}

  scholarshipSessionRecord$ = this.store.select(
    ScholarshipSessionStoreSelectors.getSelected
  );
  scholarshipSessionRecordError$ = this.store.select(
    ScholarshipSessionStoreSelectors.getScholarshipSessionError
  );

  getselected() {
    return this.store.select(ScholarshipSessionStoreSelectors.getSelected);
  }

  get isLoadingScholarshipSession() {
    this.store.dispatch(
      ScholarshipSessionStoreActions.loadScholarshipSession()
    );
    return this.store.select(
      ScholarshipSessionStoreSelectors.loadingScholarshipSession
    );
  }

  get loadScholarshipSession() {
    this.store.dispatch(
      ScholarshipSessionStoreActions.loadScholarshipSession()
    );
    return this.store.select(
      ScholarshipSessionStoreSelectors.getAllScholarshipSession
    );
  }

  addScholarshipSession(newScholarshipSession: ScholarshipSessionDto[]) {
    this.store.dispatch(
      ScholarshipSessionStoreActions.addScholarshipSession({
        newScholarshipSession,
      })
    );
  }

  updateScholarshipSession(updateScholarshipSession: ScholarshipSessionDto[]) {
    this.store.dispatch(
      ScholarshipSessionStoreActions.updateScholarshipSession({
        updateScholarshipSession,
      })
    );
  }

  removeScholarshipSession(ids: string[]) {
    this.store.dispatch(
      ScholarshipSessionStoreActions.removeScholarshipSession({ ids })
    );
  }
}
